import React, { useEffect, useMemo, useState } from 'react';
import { getNotifications, getUserById, updateUser } from '../services/api';

const CURRENT_USER_ID = 1;

export default function MyWorkProfile(){
  const [tab, setTab] = useState('inbox');
  const [notifications, setNotifications] = useState([]);
  const [user, setUser] = useState(null);

  useEffect(()=>{ getNotifications({ limit: 50 }).then(ns=> setNotifications(ns?.filter(n=>n.user_id===CURRENT_USER_ID) || [])); },[]);
  useEffect(()=>{ getUserById(CURRENT_USER_ID).then(setUser); },[]);

  return (
    <div className="space-y-4">
      <div className="bg-white border border-gray-200 rounded-xl shadow-xl shadow-gray-200/50 p-4 flex items-center justify-between">
        <div>
          <div className="text-sm text-gray-600">My Work & Profile</div>
          <div className="text-2xl font-extrabold">Welcome, {user?.name || 'User'}</div>
        </div>
        <div className="flex gap-2">
          <button onClick={()=>setTab('inbox')} className={`px-3 py-2 rounded-lg border ${tab==='inbox'?'bg-blue-600 text-white border-blue-600':'bg-white text-gray-800 border-gray-200'}`}>Inbox</button>
          <button onClick={()=>setTab('profile')} className={`px-3 py-2 rounded-lg border ${tab==='profile'?'bg-blue-600 text-white border-blue-600':'bg-white text-gray-800 border-gray-200'}`}>Profile</button>
        </div>
      </div>

      {tab==='inbox' && <InboxPanel notifications={notifications} setNotifications={setNotifications} />}
      {tab==='profile' && <ProfilePanel user={user} setUser={setUser} />}
    </div>
  );
}

function InboxPanel({ notifications, setNotifications }){
  const markRead = (id) => {
    setNotifications(notifications?.map(n=> n.id===id? { ...n, read: true } : n));
  };

  return (
    <div className="bg-white border border-gray-200 rounded-xl shadow-xl shadow-gray-200/50 p-4">
      <div className="font-semibold mb-3">Assigned Items</div>
      <div className="space-y-2">
        {notifications?.map(n=> (
          <div key={n.id} className="border border-gray-200 rounded-lg p-3 bg-gray-50 flex items-start justify-between">
            <div>
              <div className="text-sm text-gray-900">{n.message}</div>
              <div className="text-xs text-gray-600">{new Date(n.created_at).toLocaleString()}</div>
            </div>
            <div className="flex items-center gap-2">
              {!n.read && (<button onClick={()=>markRead(n.id)} className="px-3 py-1.5 rounded-lg bg-blue-600 text-white hover:bg-blue-700 transition-all">Mark Read</button>)}
              <span className={`text-xs px-2 py-0.5 rounded-full border ${n.read? 'text-gray-700 border-gray-200 bg-white':'text-blue-700 border-blue-200 bg-blue-50'}`}>{n.read? 'read':'new'}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

function ProfilePanel({ user, setUser }){
  const [name, setName] = useState(user?.name || '');
  const [email, setEmail] = useState(user?.email || '');
  const [units, setUnits] = useState(user?.preferences?.units || 'metric');

  useEffect(()=>{
    setName(user?.name || '');
    setEmail(user?.email || '');
    setUnits(user?.preferences?.units || 'metric');
  },[user]);

  const save = async () => {
    const updated = await updateUser(user?.id, { name, email, preferences: { ...(user?.preferences||{}), units } });
    setUser({ ...(user||{}), ...updated });
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div className="bg-white border border-gray-200 rounded-xl shadow-xl shadow-gray-200/50 p-4">
        <div className="font-semibold mb-2">Profile</div>
        <input value={name} onChange={e=>setName(e.target.value)} placeholder="Name" className="w-full mb-2 bg-white border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500"/>
        <input value={email} onChange={e=>setEmail(e.target.value)} placeholder="Email" className="w-full mb-3 bg-white border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500"/>
        <div className="mb-3">
          <label className="text-sm text-gray-700">Units</label>
          <select value={units} onChange={e=>setUnits(e.target.value)} className="w-full bg-white border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500">
            <option value="metric">Metric</option>
            <option value="imperial">Imperial</option>
          </select>
        </div>
        <button onClick={save} className="px-3 py-2 rounded-lg bg-blue-600 text-white hover:bg-blue-700 transition-all">Save</button>
      </div>
      <div className="bg-white border border-gray-200 rounded-xl shadow-xl shadow-gray-200/50 p-4">
        <div className="font-semibold mb-2">Sessions & Devices</div>
        <div className="text-sm text-gray-600">This demo lists your active session token in local storage if logged in.</div>
        <div className="mt-2 text-xs text-gray-700 break-all">auth_token: {localStorage.getItem('auth_token') || '—'}</div>
      </div>
    </div>
  );
}
